module.exports = __webpack_public_path__ + "img/bg_row_v2.8ba84d59.svg";